import { types } from '../const/types.task';

export function PendingRequiredFields(tabs) {
    const arr = tabs.reduce((arr, tab) => {
        const fields = tab.childs.reduce((arr, element) => {
            if (element.type === types.section) {
                const aux = element.childs.map((child) => {
                    return {
                        name: child.code,
                        tab: child.tab,
                        required: child.must && child.value === undefined,
                    };
                });
                arr = arr.concat(aux);
            }
            arr.push({
                name: element.code,
                tab: element.tab,
                required: element.must && element.value === undefined,
            });
            return arr;
        }, []);
        arr = arr.concat(fields);
        return arr;
    }, []);
    return arr.filter((f) => f.required);
}

export function PendingFilteredFields(fields, inputs) {
    const values = inputs.reduce((arr, item) => {
        if (item.value !== undefined) {
            arr.push(item.name);
        }
        return arr;
    }, []);
    return fields !== undefined
        ? fields.filter((f) => values.map((i) => i).indexOf(f.name) < 0)
        : [];
}

export function FindConditioned(rules) {
    let result = [];
    const execution = rules.filter((r) => r.tipo === 1);
    if (execution && execution.length > 0) {
        result = execution.reduce((arr, r) => {
            arr = arr.concat(
                r.accion
                    .filter((f) => f.parametros && f.parametros.campo)
                    .map((a) => a.parametros.campo.codigo),
            );
            return arr;
        }, []);
    }
    return result;
}

export function FindConditions(rules) {
    let result = [];
    const execution = rules.filter((r) => r.tipo === 1);
    if (execution && execution.length > 0) {
        result = execution.reduce((arr, r) => {
            arr = arr.concat(
                r.condicion
                    .filter((f) => f.parametros && f.parametros.campo)
                    .map((a) => a.parametros.campo.codigo),
            );
            return arr;
        }, []);
    }
    return result;
}

export function HideOld(toHide, tabs, value) {
    return tabs.map((item) => {
        if (toHide.indexOf(item.codigo) >= 0) {
            if (item.oculto !== value) {
                const d = new Date();
                item.fechahoramodificacion = formatDate(d) + ' ' + formatTime(d);
                item.usuariomodificacion = sessionStorage.user;
            }
            item.oculto = value;
            item.new =
                !value &&
                !(
                    item.valor !== undefined &&
                    item.valor !== '' &&
                    item.valor !== null &&
                    item.valor.toString().length > 0 &&
                    item.valor.toString() !== '[]'
                );
        }
        if (item.hijos) {
            item.hijos = HideOld(toHide, item.hijos, value);
        }
        return item;
    });
}

export function CleanHideValue(tabs) {
    return tabs.map((item) => {
        if (item.oculto) {
            if (
                item.valor !== undefined &&
                item.valor !== '' &&
                item.valor !== null &&
                item.valor.toString().length > 0 &&
                item.valor.toString() !== '[]'
            ) {
                const d = new Date();
                item.fechahoramodificacion = formatDate(d) + ' ' + formatTime(d);
                item.usuariomodificacion = sessionStorage.user;
            }

            item.valor = undefined;
            item.comentario = undefined;
            if (item.hijos) {
                item.hijos = MustCleanHideValue(item.hijos);
                item.pendiente = calculoPendiente(item.hijos);
                calculoPuntuacion(item, item.hijos);
            } else {
                item.puntuacionefectiva = 0;
                item.puntuacionposible = item.puntuacion;
            }
        }
        if (item.hijos) {
            item.hijos = CleanHideValue(item.hijos);
            item.pendiente = calculoPendiente(item.hijos);
            calculoPuntuacion(item, item.hijos);
        }
        return item;
    });
}

export function MustCleanHideValue(tabs) {
    return tabs.map((item) => {
        if (item.hijos) {
            item.hijos = MustCleanHideValue(item.hijos);
        }
        if (
            item.valor !== undefined &&
            item.valor !== '' &&
            item.valor !== null &&
            item.valor.toString().length > 0 &&
            item.valor.toString() !== '[]'
        ) {
            const d = new Date();
            item.fechahoramodificacion = formatDate(d) + ' ' + formatTime(d);
            item.usuariomodificacion = sessionStorage.user;

            if (item.hijos) {
                item.pendiente = calculoPendiente(item.hijos);
                calculoPuntuacion(item, item.hijos);
            } else {
                item.puntuacionefectiva = 0;
                item.puntuacionposible = item.puntuacion;
            }
        }
        item.valor = undefined;
        item.comentario = undefined;

        return item;
    });
}

/*
export function RunRules(rules, tabs) {
    let items = [...tabs];
    const valid = rules.filter((r) => r.tipo === 1);
    for (var i = 0, len = valid.length; i < len; i++) {
        items = RunRule(valid[i], items);
    }
    return items;
}

export function RunRule(rule, tabs) {
    const isOk = rule.condicion.reduce(
        (result, c) => {
            const check = ValidateCondition(c, tabs, rule);
            if (rule.yo === 1) result = result && check;
            else result = result || check;
            return result;
        },
        rule.yo === 1 ? true : false,
    );
    if (isOk) {
        const arr = rule.accion.map((a) => a.parametros.campo.codigo);
        return HideOld(arr, tabs, false);
    } else {
        return tabs;
    }
}
*/

export function RunRules(rules, tabs) {
    let items = [...tabs];
    let valid = rules.filter((r) => r.tipo === 1);
    let i = 0;
    let _continue = true;
    let _executed = false;
    while (valid.length > 0 && _continue) {
        const current = valid[i];
        let rest = JSON.parse(JSON.stringify(valid));
        delete rest[i];
        rest = rest.filter((f) => f);
        const ran = RunRule(current, items, rest);
        if (ran) {
            _executed = true;
            delete valid[i];
            valid = valid.filter((f) => f);
        }
        if (i + 1 >= valid.length) {
            if (_executed) {
                i = 0;
                _executed = false;
            } else {
                _continue = false;
            }
        } else {
            i++;
        }
    }
    return CleanHideValue(items);
}

export function RunRule(rule, elements, rules) {
    const conditions = FindConditions([rule]);
    const results = FindConditioned(rules);
    let _found = false;
    for (let i = 0; i <= conditions.length; i++ && !_found) {
        _found = results.indexOf(conditions[i]) >= 0;
    }
    if (_found) {
        return false;
    }

    const isOk = rule.condicion.reduce(
        (result, c) => {
            const check = ValidateCondition(c, elements, rule);
            if (rule.yo === 1) result = result && check;
            else result = result || check;
            return result;
        },
        rule.yo === 1 ? true : false,
    );
    if (isOk) {
        const arr = rule.accion.map((a) => a.parametros.campo.codigo);
        elements = HideOld(arr, elements, false);
    }
    return isOk;
}

export function calculoPendienteRecursivo(arr) {
    return arr.reduce((result, i) => {
        if (i.hijos && i.hijos.length > 0) {
            i.pendiente = calculoPendienteRecursivo(i.hijos);
        }
        result = result || calculoPendienteCampo(i);
        return result;
    }, false);
}

export function calculoPendiente(arr) {
    return arr.reduce((result, i) => {
        result = result || calculoPendienteCampo(i);
        return result;
    }, false);
}

function calculoPendienteCampo(i) {
    let result = false;
    if (i.hijos && i.hijos.length > 0) {
        result = result || (i.pendiente && !i.desactivado && !i.oculto);
    } else if (
        i.tipo === 'SINO' &&
        (i.estilo === 'SINONAC' || i.estilo === 'SINOC') &&
        i.obligatorio &&
        !i.desactivado
    ) {
        result =
            result ||
            (i.valor === undefined ||
            i.valor === null ||
            (i.valor === false && (!i.comentario || i.comentario.length < 4))
                ? true
                : false);
    } else if (
        i.valor !== undefined &&
        i.valor !== '' &&
        i.valor !== null &&
        i.valor.toString().length > 0 &&
        i.valor.toString() !== '[]'
    ) {
        result = result || false;
    } else if (i.tipo === 'PESTANA' || i.tipo === 'SECCION') {
        result = result || false;
    } else {
        result = result || (i.obligatorio && !i.desactivado && !i.oculto);
    }
    //console.log(i.nombre, (i.valor === undefined || i.valor === null), result );
    return result;
}

export function calculoPuntuacion(item, arr) {
    if (arr !== undefined && arr.length > 0) {
        arr.map((hijo) => calculoPuntuacion(hijo, hijo.hijos));
        const puntuacionhijos = arr.reduce((total, hijo) => {
            if (!hijo.desactivado && !hijo.oculto) {
                total += hijo.puntuacionposible;
            }
            return total;
        }, 0);
        const puntoshijos = arr.reduce((total, hijo) => {
            if (!hijo.desactivado && !hijo.oculto) {
                total += hijo.puntuacionefectiva;
            }
            return total;
        }, 0);

        if (item.puntuacion === 0) {
            item.puntuacionposible = puntuacionhijos;
            item.puntuacionefectiva = puntoshijos;
        } else {
            item.puntuacionposible = item.puntuacion;
            if (puntuacionhijos > 0) {
                const cofiente = item.puntuacionposible / puntuacionhijos;
                item.puntuacionefectiva = Math.round(puntoshijos * cofiente * 100) / 100;
            } else {
                item.puntuacionefectiva = 0;
            }
        }
    }
}

export function ValidateCondition(condition, tabs, rule) {
    const codigo = condition.parametros.campo.codigo;
    const valor = condition.parametros.valor;
    const field = findItem(tabs, codigo);
    if (!field || (field.oculto && condition.tipo !== 11)) {
        return false;
    }
    switch (condition.tipo) {
        case 0:
            return (
                field.valor !== undefined &&
                field.valor !== '' &&
                field.valor !== null &&
                field.valor.toString().length > 0 &&
                field.valor.toString() !== '[]'
            );
        case 1:
            return !(
                field.valor !== undefined &&
                field.valor !== '' &&
                field.valor !== null &&
                field.valor.toString().length > 0 &&
                field.valor.toString() !== '[]'
            );
        case 2:
            return field.valor === true;
        case 3:
            return field.valor === false;
        case 4:
            return !!field.comentario;
        case 5: // on range
            switch (field.type) {
                case types.boolean:
                case types.action:
                    return field.alertable !== undefined && field.valor !== field.alertable;
                case types.number:
                case types.real:
                case types.auto:
                case types.temp:
                    return field.valor && !isOutRangeReal(field.valor, field.alertable);
                case types.date:
                    return field.valor && !isOutRangeDate(field.valor, field.alertable);
                case types.datetime:
                    return field.valor && !isOutRangeDateTime(field.valor, field.alertable);
                default:
                    return false;
            }
        case 6: // out range
            switch (field.type) {
                case types.boolean:
                case types.action:
                    return field.alertable !== undefined && field.valor === field.alertable;
                case types.number:
                case types.real:
                case types.auto:
                case types.temp:
                    return isOutRangeReal(field.valor, field.alertable);
                case types.date:
                    return isOutRangeDate(field.valor, field.alertable);
                case types.datetime:
                    return isOutRangeDateTime(field.valor, field.alertable);
                default:
                    return false;
            }
        case 7: // multiseleted option
            const options = field.valor ? field.valor.split(',').length : 0;
            return options > 1;
        case 8: // temp modified
            return field && field.metados && field.metados.manually;
        case 9: // option selected
            switch (field.type) {
                case types.multioption:
                    const values = field.valor ? field.valor.toString().split(',') : [];
                    return valor && values.indexOf(valor.toString()) >= 0;
                case types.options:
                    return valor && field.valor && field.valor.toString() === valor.toString();
                default:
                    return false;
            }
        case 10:
            return !field.oculto;
        case 11:
            return field.oculto;
        case 12:
            return valor && field.comentario && field.comentario.toString() === valor.toString();
        default:
            return false;
    }
}

export function findItem(arr, codigo) {
    let item = undefined;
    arr.forEach((i) => {
        if (i.hijos && i.hijos.length > 0) {
            let aux = findItem(i.hijos, codigo);
            if (aux) {
                item = aux;
            }
        }
        if (i.codigo === codigo) {
            item = i;
        }
    });

    return item;
}

export const isOutRangeReal = (valor, range) => {
    let result = false;
    if (range && valor) {
        const reference = parseFloat(valor);
        if (range.inferior && range.limiteinferior) {
            result = result || reference < parseFloat(range.inferior);
        } else if (range.inferior) {
            result = result || reference <= parseFloat(range.inferior);
        }
        if (range.superior && range.limitesuperior) {
            result = result || reference > parseFloat(range.superior);
        } else if (range.superior) {
            result = result || reference >= parseFloat(range.superior);
        }
    }
    return result;
};

export function parseDate(input) {
    // eslint-disable-next-line
    const format = input.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)
        ? 'dd/mm/yyyy'
        : 'yyyy-mm-dd'; // default format
    var parts = input.match(/(\d+)/g),
        i = 0,
        fmt = {};
    // extract date-part indexes from the format
    format.replace(/(yyyy|dd|mm)/g, function(part) {
        fmt[part] = i++;
    });

    return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]);
}

function parseDateTime(input) {
    const date = input.replace('T', ' ').split(' ')[0];
    const time = input.replace('T', ' ').split(' ')[1];
    // eslint-disable-next-line
    const format = date.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/)
        ? 'dd/mm/yyyy'
        : 'yyyy-mm-dd'; // default format
    var parts = date.match(/(\d+)/g),
        i = 0,
        fmt = {};
    // extract date-part indexes from the format
    format.replace(/(yyyy|dd|mm)/g, function(part) {
        fmt[part] = i++;
    });

    return new Date(parts[fmt['yyyy']], parts[fmt['mm']] - 1, parts[fmt['dd']]).setHours(
        time.split(':')[0],
        time.split(':')[1],
        0,
        0,
    );
}

export const isOutRangeDate = (date, range) => {
    const conditions = range && (range.inferior || range.superior) ? {} : undefined;
    if (range.inferior) {
        var fechaInferior = new Date();
        fechaInferior.setDate(
            fechaInferior.getDate() + parseInt(range.inferior, 10) + (range.limiteinferior ? 0 : 1),
        );
        conditions.min = formatDate(fechaInferior);
    }
    if (range.superior) {
        var fechaSuperior = new Date();
        fechaSuperior.setDate(
            fechaSuperior.getDate() + parseInt(range.superior, 10) - (range.limitesuperior ? 0 : 1),
        );
        conditions.max = formatDate(fechaSuperior);
    }
    if (!conditions) return false;
    else {
        if (!date) return false;
        else {
            if (
                conditions.min &&
                new Date(parseDate(date)).valueOf() < new Date(parseDate(conditions.min)).valueOf()
            ) {
                return true;
            }
            if (
                conditions.max &&
                new Date(parseDate(date)).valueOf() > new Date(parseDate(conditions.max)).valueOf()
            ) {
                return true;
            }
            return false;
        }
    }
};

export const isOutRangeDateTime = (date, range) => {
    const conditions = range && (range.inferior || range.superior) ? {} : undefined;
    if (range.inferior) {
        conditions.min = formatDateTime(
            new Date(
                new Date().getTime() -
                    (parseInt(range.inferior, 10) + (range.limiteinferior ? 0 : 1)) *
                        60 *
                        60 *
                        1000,
            ),
        );
    }
    if (range.superior) {
        conditions.max = formatDateTime(
            new Date(
                new Date().getTime() +
                    (parseInt(range.superior, 10) - (range.limitesuperior ? 0 : 1)) *
                        60 *
                        60 *
                        1000,
            ),
        );
    }
    if (!conditions) return false;
    else {
        if (!date) return false;
        else {
            if (
                conditions.min &&
                new Date(parseDateTime(date)).valueOf() <
                    new Date(parseDateTime(conditions.min)).valueOf()
            ) {
                return true;
            }
            if (
                conditions.max &&
                new Date(parseDateTime(date)).valueOf() >
                    new Date(parseDateTime(conditions.max)).valueOf()
            ) {
                return true;
            }
            return false;
        }
    }
};

export function formatDateTime(d) {
    if (d instanceof Date) {
        function pad(s) {
            return s < 10 ? '0' + s : s;
        }
        return (
            [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-') +
            ' ' +
            [pad(d.getHours()), pad(d.getMinutes())].join(':')
        );
    }
    return d;
}

export function formatDate(d) {
    if (d) {
        function pad(s) {
            return s < 10 ? '0' + s : s;
        }
        return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
    }
    return d;
}

export function formatTime(d) {
    function pad(s) {
        return s < 10 ? '0' + s : s;
    }
    return [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
}

export function isCondition(rule, code) {
    return rule.condicion.reduce((is, a) => {
        if (a.parametros && a.parametros.campo && a.parametros.campo.codigo === code) {
            is = true;
        }
        return is;
    }, false);
}

export function isAction(rule, code) {
    return rule.accion.reduce((is, a) => {
        if (a.parametros && a.parametros.campo && a.parametros.campo.codigo === code) {
            is = true;
        }
        return is;
    }, false);
}



// WEBPACK FOOTER //
// ./src/functions/forms.js